<template>
  <div>
    <Navbar></Navbar>
    <DashboardContent v-if="!forbidden" :deleted="this.deleted ? this.deleted : false"/>
    <div class="forbidden" v-if="forbidden">
      <div class="msg">You are not authorized to access this event</div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import DashboardContent from "@/components/DashboardContent";
import config from "@/config/config";
import axios from "axios";

//STAGING
window.ENDPOINT = `https://draw-api.gevme.com/`;
window.REDIRECT_URI = `https://draw.gevme.com`;
window.CLIENT_ID = "a-18-6paX0FtFFaJg";

// PROD
// Config for PROD env comes here

export default {
  name: "Dashboard",
  data() {
    return {
      authCode: window.location.search.includes("code")
        ? window.location.search.split("?code=")[1].split("&state=")[0]
        : "",
      eventId: window.location.search.includes("state")
        ? window.location.search.split("?code=")[1].split("&state=")[1]
        : "",
      forbidden: false
    };
  },
  props: ["deleted"],
  components: {
    DashboardContent,
    Navbar
  },
  mounted() {
    Event.$on("Get Gevme Data", async ({ gevmeUser }) => {
      Event.$emit("Gevme User Profile", gevmeUser);
      var eventDetail = await fetch(
        `${config.gevmeEndPoint}/api/events/${localStorage.getItem(
          "event_id"
        )}?access_token=${localStorage.getItem("gevme_access_token")}`
      );
      var eventResp = await eventDetail.json();

      if (eventResp.error && eventResp.error == "forbidden") {
        this.forbidden = true;
      }

      Event.$emit("Gevme Event Detail", eventResp);
    });

    if (
      window.location.search.includes("event_id") &&
      !window.location.search.includes("code")
    ) {
      this.eventId = window.location.search.split("?event_id=")[1];

      localStorage.setItem("event_id", this.eventId);
    }
    if (this.authCode !== "" && this.eventId !== "") {
      localStorage.setItem("auth_code", this.authCode);
      localStorage.setItem("event_id", this.eventId);
      axios
        .post(ENDPOINT, {
          query: `
                  mutation {
                    authenticate(code: "${
                      this.authCode
                    }", redirect_uri:"${REDIRECT_URI}") {
                      token
                      access_token
                      gevmeUser
                    }
                  }
                `,
          variables: null
        })
        .then(
          async function(response) {
            localStorage.setItem(
              "gevme_token",
              response.data.data.authenticate.token
            );
            localStorage.setItem(
              "gevme_access_token",
              response.data.data.authenticate.access_token
            );
            window.history.replaceState({}, document.title, "/");
            Event.$emit("Get Gevme Data", {
              gevmeUser: response.data.data.authenticate.gevmeUser
            });
            Event.$emit("Event ID Set");
          }.bind(this)
        );
    } else {
      var event_id = localStorage.getItem("event_id");
      if (!event_id) {
        alert("Event not found");
        return;
      }

      window.location.href = `${
        config.gevmeEndPoint
      }/api/oauth/authorize?response_type=code&client_id=${CLIENT_ID}&scope=attendee_attendee,admin,user&redirect_uri=${REDIRECT_URI}&state=${event_id}`;

      return;
      axios
        .post(
          ENDPOINT,
          {
            query: `
                  query {
                    me
                  }
                `,
            variables: null
          },
          {
            headers: {
              Authorization: localStorage.getItem("gevme_token")
            }
          }
        )
        .then(
          async function(response) {
            Event.$emit("Get Gevme Data", { gevmeUser: response.data.data.me });
            Event.$emit("Event ID Set");
          }.bind(this)
        );
    }
  }
};
</script>

<style scoped>
.forbidden {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.forbidden .msg {
  font-size: 14px;
  color: #000;
  background-color: #fff;
  border-radius: 5px;
  width: 350px;
  padding: 20px 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue